(function () {
  const CHECKOUT_BUTTON_SELECTOR = '[data-bodf-checkout-button], .cart__checkout-button[name="checkout"]';
  const LOADING_BUTTON_SELECTOR =
    '[data-bodf-checkout-button][data-bodf-checkout-loading], .cart__checkout-button[name="checkout"][data-bodf-checkout-loading]';
  const FALLBACK_REDIRECT_DELAY = 3500;
  const RECOVERY_DELAY = 3500;

  let checkoutState = null;
  let fallbackTimer = null;
  let recoveryTimer = null;

  function log(message) {
    console.info(`[BODF Checkout] ${message}`);
  }

  function logError(error) {
    console.error('[BODF Checkout ERROR]', error);
  }

  function findStatus(button) {
    const ctas = button.closest('.cart__ctas');
    return ctas ? ctas.querySelector('[data-bodf-checkout-status]') : null;
  }

  function setStatus(button, message, isError) {
    const status = findStatus(button);
    if (!status) return;

    status.textContent = message || '';
    status.hidden = !message;
    status.dataset.state = isError ? 'error' : 'info';
  }

  function setLoading(button, isLoading) {
    button.toggleAttribute('data-bodf-checkout-loading', isLoading);
    button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    button.setAttribute('aria-disabled', isLoading ? 'true' : 'false');

    if (isLoading) {
      setStatus(button, 'Redirecting to secure checkout...', false);
      return;
    }

    setStatus(button, '', false);
  }

  function clearTimers() {
    if (fallbackTimer) {
      window.clearTimeout(fallbackTimer);
      fallbackTimer = null;
    }

    if (recoveryTimer) {
      window.clearTimeout(recoveryTimer);
      recoveryTimer = null;
    }
  }

  function findCurrentButton() {
    if (!checkoutState) return null;
    if (checkoutState.button.isConnected) return checkoutState.button;

    if (checkoutState.formId) {
      const formButton = Array.from(document.querySelectorAll(CHECKOUT_BUTTON_SELECTOR)).find(function (button) {
        return button.getAttribute('form') === checkoutState.formId;
      });
      if (formButton) return formButton;
    }

    return document.querySelector(LOADING_BUTTON_SELECTOR);
  }

  function restoreCheckout() {
    const currentButton = findCurrentButton();
    clearTimers();

    document.querySelectorAll(LOADING_BUTTON_SELECTOR).forEach(function (button) {
      setLoading(button, false);
    });

    if (currentButton) {
      setLoading(currentButton, false);
    }

    checkoutState = null;
    log('button restored');
  }

  function getForm(button) {
    const formId = button.getAttribute('form');
    return button.form || (formId ? document.getElementById(formId) : null);
  }

  function ensureCheckoutInput(form) {
    let input = form.querySelector('input[name="checkout"][data-bodf-checkout-input]');

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'checkout';
      input.value = 'Checkout';
      input.dataset.bodfCheckoutInput = 'true';
      form.appendChild(input);
    }
  }

  function getCheckoutUrl() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? `${window.Shopify.routes.root}checkout`
      : '/checkout';
  }

  function scheduleRecovery() {
    recoveryTimer = window.setTimeout(function () {
      if (!checkoutState) return;
      log('navigation timeout recovery');
      restoreCheckout();
    }, RECOVERY_DELAY);
  }

  function attemptFallbackNavigation() {
    if (!checkoutState || checkoutState.fallbackAttempted) return;

    checkoutState.fallbackAttempted = true;
    log('fallback navigation');

    try {
      window.location.assign(getCheckoutUrl());
    } catch (error) {
      logError(error);
      restoreCheckout();
      return;
    }

    scheduleRecovery();
  }

  function startCheckout(button, form) {
    clearTimers();
    checkoutState = {
      button,
      formId: form ? form.id : button.getAttribute('form'),
      fallbackAttempted: false,
      startedAt: Date.now(),
    };
    setLoading(button, true);

    fallbackTimer = window.setTimeout(attemptFallbackNavigation, FALLBACK_REDIRECT_DELAY);
  }

  document.addEventListener(
    'click',
    function (event) {
      const button = event.target instanceof Element ? event.target.closest(CHECKOUT_BUTTON_SELECTOR) : null;
      if (!button) return;

      if (button.disabled || button.hasAttribute('data-bodf-checkout-loading')) {
        event.preventDefault();
        return;
      }

      const form = getForm(button);
      log('click');

      if (!form) {
        event.preventDefault();
        startCheckout(button, null);
        attemptFallbackNavigation();
        return;
      }

      ensureCheckoutInput(form);
      startCheckout(button, form);
      log('native submit starting');
    },
    true
  );

  document.addEventListener('visibilitychange', function () {
    if (!checkoutState) return;

    const elapsed = Date.now() - checkoutState.startedAt;
    if (!checkoutState.fallbackAttempted && elapsed >= FALLBACK_REDIRECT_DELAY) {
      attemptFallbackNavigation();
      return;
    }

    if (checkoutState.fallbackAttempted && elapsed >= FALLBACK_REDIRECT_DELAY + RECOVERY_DELAY) {
      log('navigation timeout recovery');
      restoreCheckout();
    }
  });

  window.addEventListener('pagehide', restoreCheckout);
  window.addEventListener('pageshow', restoreCheckout);
})();
